import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgInstallmentplan32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M13 5c2.198 0 4.303.647 6.094 1.84a1 1 0 0 1 .278 1.387L14.866 15H23a1 1 0 0 1 1 1c0 6.075-4.925 11-11 11S2 22.075 2 16 6.925 5 13 5m0 1C7.477 6 3 10.477 3 16s4.477 10 10 10 10-4.477 10-10h-8.134a1 1 0 0 1-.832-1.554l4.505-6.773A9.953 9.953 0 0 0 13 6m12.295-1.923C28.204 5.907 30 9.053 30 12.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.411-.784l5.528-8a.5.5 0 0 1 .678-.14m-.134 1.111L20.453 12h8.533c-.155-2.741-1.575-5.229-3.825-6.812"
        className="installmentplan-32_svg__path-1"
      />
    </SvgIcon>
  );
};
const Memo = memo(SvgInstallmentplan32);
export default Memo;
